import apiClient from './axios';
import { ApiResponse } from '../types';

export interface PendingAddressVerification {
  id: string;
  name: string | null;
  email: string | null;
  phoneNumber: string | null;
  tier: string;
  address: string | null;
  state: string | null;
  lga: string | null;
  landmark: string | null;
  documentUrl: string | null;
  documentType: string | null;
  submittedAt: string;
}

export type KycDecision = 'verified' | 'rejected';

export const kycApi = {
  listPendingAddress: async () => {
    const { data } = await apiClient.get<ApiResponse<PendingAddressVerification[]>>(
      '/admin/users/kyc/pending-address',
    );
    return data.data;
  },

  decideAddress: async (userId: string, status: KycDecision, reason?: string) => {
    const { data } = await apiClient.patch<ApiResponse<unknown>>(
      `/admin/users/${userId}/kyc/address-document`,
      { status, reason },
    );
    return data.data;
  },
};
